import * as baseAdapter from './baseAdapter';

export const jobProcess = async (key: 'invoice' | 'billing' | 'payment') => {
  const ret = await baseAdapter.post(
    `/v1/job/${key}?token=bad47f55-a067-4746-ab3c-729f9a2713a6`,
    {}
  );
  return ret;
};
